// extracted by mini-css-extract-plugin
export var footer = "_n7-0";
export var inherit = "_n7-1";
export var input = "_n7-2";
export var modalContent = "_n7-3";
export var quillEditor = "_n7-4";
export var subtitle = "_n7-5";